import React, {useEffect, useState} from 'react'
import {DataGrid, GridRowsProp, GridColDef} from '@material-ui/data-grid'
import {useDispatch, useSelector} from 'react-redux'
import {actions as actionActions} from 'src/redux/modules/actions'
import {RootState} from '../../redux/rootReducer'
import {Root, Button, Thumbnail} from './styled'
import _ from 'lodash'
import Action from 'src/models/Action'
import {useHistory} from 'react-router'
import VideoPlayer from 'src/components/VideoPlayer'
import ManagementTemplate from 'src/components/ManagementTemplate'

const ActionsPage: React.FC = () => {
  const history = useHistory()
  const [playVideoURL, setPlayVideoURL] = useState<string | undefined>()
  const {actions, dataState} = useSelector((state: RootState) => state.actions)
  const dispatch = useDispatch()

  const onCreateActionClick = () => {
    history.push('/actions/create')
  }

  const onDeleteActionClick = (params: any) => {
    window.confirm('Are you sure you want to delete?')
    dispatch(actionActions.deleteAction({actionId: params.id as string}))
  }

  const loadActions = () => {
    dispatch(actionActions.getAllActions())
  }
  useEffect(loadActions, [dispatch])
  const values = _.values(actions) as Action[]
  const rows: GridRowsProp = values.map(
    ({id, title, thumbnailUrl, setsAndReps, videoUrl, author, description}) => ({
      id,
      description,
      title,
      thumbnailUrl,
      videoUrl,
      setsAndReps,
      author: author.name,
    }),
  )
  const columns: GridColDef[] = [
    {field: 'title', headerName: 'Title', width: 200},
    {
      field: 'thumbnailUrl',
      headerName: 'Video',
      width: 200,
      renderCell: (params) => <Thumbnail variant="square" src={params.value as string} />,
    },
    {
      field: 'videoUrl',
      headerName: ' ',
      width: 100,
      renderCell: (params) => (
        <Button variant="contained" onClick={() => setPlayVideoURL(params.value as string)}>
          View
        </Button>
      ),
    },
    {field: 'setsAndReps', headerName: 'Sets and reps', width: 150},
    {field: 'description', headerName: 'Description', flex: 1},
    {field: 'author', headerName: 'Author', width: 150},
    {
      field: 'id',
      headerName: '++',
      width: 200,
      renderCell: (params) => (
        <>
          <Button
            variant="contained"
            color="primary"
            onClick={() => history.push(`/actions/${params.value}`)}>
            Edit
          </Button>
          <Button variant="contained" color="secondary" onClick={() => onDeleteActionClick(params)}>
            Delete
          </Button>
        </>
      ),
    },
  ]

  return (
    <Root>
      <ManagementTemplate
        title="Manage Actions"
        busy={dataState.state === 'loading'}
        error={dataState.error}
        createButtonTitle="Create Action"
        onCreateClick={() => onCreateActionClick()}>
        <DataGrid
          disableSelectionOnClick
          rowHeight={100}
          autoHeight
          rows={rows}
          columns={columns}
        />
      </ManagementTemplate>
      <VideoPlayer streamingURL={playVideoURL} onClose={() => setPlayVideoURL(undefined)} />
    </Root>
  )
}

export default ActionsPage
